import React, { useState, useRef, useEffect } from 'react';

const CustomSelect = ({ options, placeholder, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const dropdownRef = useRef(null);

    const handleToggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (option) => {
        const newSelectedOptions = selectedOptions.includes(option)
            ? selectedOptions.filter((item) => item !== option)
            : [...selectedOptions, option];

        setSelectedOptions(newSelectedOptions);
        onChange(newSelectedOptions);
        setSearchQuery('');
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleRemoveOption = (option) => {
        const newSelectedOptions = selectedOptions.filter((item) => item !== option);
        setSelectedOptions(newSelectedOptions);
        onChange(newSelectedOptions);
    };

    const filteredOptions = options.filter((option) =>
        option.label.toLowerCase().includes(searchQuery.toLowerCase())
    );

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="custom-select" ref={dropdownRef}>
            <div className="select-input" onClick={handleToggleDropdown} style={{ borderColor : isOpen ? '#007FFF' : '#E9E9E9'}}>
                <div className="selected-options">
                    {selectedOptions.map((option) => (

                        <div key={option.value} className="selected-option">
                            {option.label}
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" onClick={() => handleRemoveOption(option)}>
                                <path d="M12 12L8.00001 8.00001M8.00001 8.00001L4 4M8.00001 8.00001L12 4M8.00001 8.00001L4 12" stroke="#C2C2C2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>


                    ))}
                    <input
                        type="text"
                        className="select-search"
                        placeholder={placeholder}
                        value={searchQuery}
                        onChange={handleSearchChange}
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsOpen(true);
                        }}
                    />
                </div>

                {/* <span className={`arrow ${isOpen ? 'open' : ''}`}>▼</span> */}
            </div>
            {isOpen && (
                <div className="select-dropdown">
                    {filteredOptions.map((option) => (
                        <div
                            key={option.value}
                            className={`select-option ${selectedOptions.includes(option) ? 'selected' : ''}`}
                            onClick={() => handleOptionClick(option)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;